import axios from "axios";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logEvent } from "../../utils/Analytics";
const EmployerConnectInfo = () => {
  const { user } = useSelector((state) => state.user);
  const [connectCredit, setConnectCredit] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [showConnects, setShowConnects] = useState({
    jobconn: "",
    InternshipConn: "",
    connectperView: "",
  });

  useEffect(() => {
    async function handleGetRate() {
      const response = await axios.get("/api/admin/getconnectinformationadmin");
      const {
        connectperjob,
        connectperinternship,
        connectperjobseekercontact,
      } = response.data;
      setShowConnects({
        jobconn: connectperjob,
        InternshipConn: connectperinternship,
        connectperView: connectperjobseekercontact,
      });
    }
    handleGetRate();
  }, []);

  useEffect(() => {
    const getConnectCreditInfo = async () => {
      try {
        setLoading(true);
        const response = await axios.get(
          `/api/employer/getConnectCreditInfomrationofEmployer/${user?._id}`,
        );
        setConnectCredit(response.data.connectCredit);
        console.log(response.data);
      } catch (error) {
        console.error("Error fetching connectCredit:", error);
      } finally {
        setLoading(false);
      }
    };

    if (user && user.role === "Employer") {
      getConnectCreditInfo();
    }
  }, [user]);
  const handleBuyConnects = () => {
    navigate("/employerbuyconnects");
  };
  const handleBack = () => {
    // navigate('/employerApplication')
    navigate("/employerApplication/Internship");
  };

  const handleAddEvent = (str) => {
    logEvent("Button", `Clicked ${str} button`);
  };
  return (
    <>
      <div className="myapplicationsbuymain">
        <div className="my-applicationsbuyconnects2">
          <div
            className="my-applicationsbuyconnectsheader"
            style={{ height: "50px", fontWeight: "700", padding: "17px" }}
          >
            Connects Summary
          </div>
          <div className="my-applicationsbuyconnectsbodyinformation">
            <div style={{ display: "flex", gap: "5px" }}>
              {connectCredit && (
                <div
                  style={{
                    fontSize: "16px",
                    fontWeight: "500",
                    marginBottom: "11px",
                  }}
                >
                  Your Available Connects :
                </div>
              )}

              <div>
                {!loading && connectCredit && <b>{connectCredit}</b>}
                {!loading && !connectCredit && (
                  <i>Please create your organization First To get Credit</i>
                )}
              </div>
            </div>

            <div>
              <b>1</b> Job post requires <b>{showConnects.jobconn}</b> connects
            </div>
            <div>
              <b>1</b> Internship post requires{" "}
              <b>{showConnects.InternshipConn}</b> connects
            </div>
            {/* <div><b>1</b> contact view requires <b>1</b> connect</div> */}
            <div>
              Viewing job seekers' contacts (email, phone, direct chat) on the
              "Job Seekers" page, requires <b>{showConnects.connectperView}</b>{" "}
              connect
            </div>

            <div
              style={{
                display: "flex",
                alignItems: "flex-end",
                alignSelf: "end",
                gap: "10px",
              }}
            >
              <button
                className="employerbuttonbacktodash"
                onClick={() => {
                  handleBack();
                  handleAddEvent("Back");
                }}
              >
                Back
              </button>
              <button
                className="employerbuttontobuyinformation"
                onClick={() => {
                  handleBuyConnects();
                  handleAddEvent("Buy connects");
                }}
              >
                Buy Connects
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EmployerConnectInfo;
